const ApiRoute = "/MVC/Auditing";
export default ApiRoute;
